import { Button, TextField } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { searchProducts } from '../../actions/productActions';

import useStyles from './styles'

const SearchBar = () => {
    
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    
    const [search, setSearch] = useState('')
    const user = JSON.parse(localStorage.getItem('retailer'))

    const searchPost = () => {
        if (search.trim()) {
        dispatch(searchProducts({ search }));
        setSearch('')
        } else {
        history.push('/');
        }
    };
    return ( 
        <div className={classes.paper}>
              <TextField autoComplete='off' style={{height: '80%', marginTop: '-.7rem'}} name="search" variant='standard' label="Search Products" value={search} onChange={(e) => setSearch(e.target.value)} />
              <Button onClick={searchPost} variant='outlined' color={user? 'secondary' :'primary'} >Search</Button>
        </div>
     );
}
 
export default SearchBar;